var map = {
	"./hy0.png": "RY9P",
	"./hy1.png": "mrXu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HZWZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index ^\.\/hy.*\.png$
// module id = HZWZ
// module chunks = 3